module.exports = __webpack_public_path__ + "static/media/CakeBanner.6d494764.svg";